import React, { useState, useEffect } from "react";
import { Navbar, Container, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { logout } from "../../Utils/Auth";
import { active_component } from "../../Utils/userFunctions";
function UserHeader() {
  const [dash_button_active_status, setDash_button_active_status] =
    useState("");
  const [device_button_active_status, setDevice_button_active_status] =
    useState("");
  const [surveys_button_active_status, setSurveys_button_active_status] =
    useState("");

  useEffect(() => {
    let values = active_component();
    setDash_button_active_status(values.button_dash);
    setDevice_button_active_status(values.button_devices);
    setSurveys_button_active_status(values.button_surveys);
  }, []);

  return (
    <>
      <header className="header_background">
        <Container>
          <Navbar>
            <Navbar.Brand>
              <Link to="/UserDashboard">
                <img
                  src={require("../../Assets/Images/fpmcf_logo.png")}
                  alt="N/A"
                  className="dev_height"
                />
              </Link>{" "}
            </Navbar.Brand>
            <div className="navbar-collapse collapse">
              <div className="nav navbar-nav navbar-center">
                <li></li>
              </div>
            </div>
            
            {(localStorage.getItem("user_type") == 3 ||
              localStorage.getItem("user_type") == 2) && (
              <>
                
                <Navbar.Collapse className="justify-content-end">
                
                 
              
                  <NavDropdown
                    title={
                      <img
                        className="dev_height"
                        alt="N/A"
                        src={require("../../Assets/Images/email.png")}
                      />
                    }
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item>
                      <Link to="/my-profile">My Profile</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                      <Link to="/UserChangePassword">Change Password</Link>
                    </NavDropdown.Item>

                    <NavDropdown.Item to="/logout" onClick={logout}>
                      Sign Out
                    </NavDropdown.Item>
                  </NavDropdown>
                </Navbar.Collapse>
                <b className="custom-text-primary">
                {localStorage.getItem("first_name")}
                </b>
                
              </>
            )}
          </Navbar>
        </Container>
      </header>
      {(localStorage.getItem("user_type") == 3 ||
        localStorage.getItem("user_type") == 2) && (
        <>
          <div className="container">
            <div className="dash_button_box">
              <Link to="/UserDashboard">
                <button type="button" className={dash_button_active_status}>
                  <i className="fa fa-home"></i> Dashboard
                </button>
              </Link>
              &nbsp;
              <Link to="/UserDevices">
                <button type="button" className={device_button_active_status}>
                  <i className="fa fa-medkit"></i> Devices
                </button>
              </Link>
              &nbsp;
              <Link to="/UserListSurveys">
                <button type="button" className={surveys_button_active_status}>
                  <i className="fa fa-list"></i> Surveys
                </button>
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default UserHeader;
